import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "welcome"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "grid-content"
};
const _hoisted_4 = {
  class: "list-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "grid-content"
};
const _hoisted_7 = {
  class: "list-box"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "grid-content"
};
const _hoisted_10 = {
  class: "list-box"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["onClick"];
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { getSystemInfo } from "@/store/cache";
export default {
  __name: 'MessageListEmpty',
  emits: ["onPrompt"],
  setup(__props, {
    emit: __emit
  }) {
    const title = ref(process.env.VUE_APP_TITLE);
    const version = ref(process.env.VUE_APP_VERSION);
    const samples = ref(["用生动的比喻解释区块链技术的工作原理", "为一家新开的咖啡店设计吸引人的广告语和品牌故事", "写一封礼貌的邮件拒绝客户的不合理要求", "推荐几部最近值得观看的科幻电影，并简要介绍剧情"]);
    const plugins = ref([{
      value: "天气查询",
      text: "天气查询：获取当前和未来几天的天气预报信息"
    }, {
      value: "股票查询",
      text: "股票查询：实时查询指定股票的价格和走势分析"
    }, {
      value: "汇率换算",
      text: "汇率换算：查询不同货币之间的实时汇率"
    }, {
      value: "快递查询",
      text: "快递查询：通过快递单号查询包裹物流信息"
    }]);
    const capabilities = ref([{
      text: "角色扮演：可以扮演历史人物、小说角色或虚拟助手进行对话",
      value: ""
    }, {
      text: "多语言支持：支持中、英、日、韩等多种语言的翻译和对话",
      value: ""
    }, {
      text: "代码生成：根据需求生成多种编程语言的代码片段",
      value: "生成一个Vue3的计数器组件，使用Composition API"
    }, {
      text: "数据分析：可以处理和分析CSV数据并生成可视化图表建议",
      value: ""
    }]);
    const emits = __emit;
    const send = text => {
      emits("onPrompt", text);
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("h2", {
        class: "title"
      }, "乐和 AI", -1)), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-quick-start"
          })]), _createElementVNode("div", null, "快速上手")], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samples.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item
            }, [_createElementVNode("a", {
              onClick: $event => send(item)
            }, _toDisplayString(item), 9, _hoisted_5)]);
          }), 128))])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-plugin"
          })]), _createElementVNode("div", null, "实用工具")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plugins.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item.value
            }, [_createElementVNode("a", {
              onClick: $event => send(item.value)
            }, _toDisplayString(item.text), 9, _hoisted_8)]);
          }), 128))])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "item-title"
          }, [_createElementVNode("div", null, [_createElementVNode("i", {
            class: "iconfont icon-control"
          })]), _createElementVNode("div", null, "特色专长")], -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capabilities.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item
            }, [item.value === '' ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.text), 1)) : (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: $event => send(item.value)
            }, _toDisplayString(item.text), 9, _hoisted_12))]);
          }), 128))])])])]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
};